<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p> {{ $t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.title') }} </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field :label="$t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.ecriture')">
            <b-input :value="sens === sensVente
            ? domiciliationBancaire.libelleEcritureReglement
            : domiciliationBancaire.libelleEcriturePaiement"
                     @focus="$emit('editInformation',
                     'ecriture', sens === sensVente
            ? domiciliationBancaire.libelleEcritureReglement
            : domiciliationBancaire.libelleEcriturePaiement, sens, false)"/>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.ecritureTiers')">
            <b-input :value="sens === sensVente
            ? domiciliationBancaire.libelleLigneEcritureReglementTiers
            : domiciliationBancaire.libelleLigneEcriturePaiementTiers"
                     @focus="$emit('editInformation', 'ecritureTiers',
                          sens === sensVente
            ? domiciliationBancaire.libelleLigneEcritureReglementTiers
            : domiciliationBancaire.libelleLigneEcriturePaiementTiers, sens, false)"/>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.ecritureBanque')">
            <b-input :value="sens === sensVente
            ? domiciliationBancaire.libelleLigneEcritureReglementBanque
            : domiciliationBancaire.libelleLigneEcriturePaiementBanque"
                     @focus="$emit('editInformation', 'ecritureBanque',
                          sens === sensVente
            ? domiciliationBancaire.libelleLigneEcritureReglementBanque
            : domiciliationBancaire.libelleLigneEcriturePaiementBanque, sens, false)"/>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.referenceTiers')">
            <b-input :value="sens === sensVente
            ? domiciliationBancaire.libelleReferenceReglementTiers
            : domiciliationBancaire.libelleReferencePaiementTiers"
                     @focus="$emit('editInformation', 'referenceTiers',
                          sens === sensVente
            ? domiciliationBancaire.libelleReferenceReglementTiers
            : domiciliationBancaire.libelleReferencePaiementTiers, sens, true)"/>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('addDomiciliationBancaire.parametrageLibelle.' + sens + '.referenceBanque')">
            <b-input :value="sens === sensVente
            ? domiciliationBancaire.libelleReferenceReglementBanque
            : domiciliationBancaire.libelleReferencePaiementBanque"
                     @focus="$emit('editInformation', 'referenceBanque',
                          sens === sensVente
            ? domiciliationBancaire.libelleReferenceReglementBanque
            : domiciliationBancaire.libelleReferencePaiementBanque, sens, true)"/>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SENS_VENTE } from '@/configuration/devisConf';

export default {
  props: {
    domiciliationBancaire: {
      type: Object,
      required: true,
    },
    sens: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sensVente: SENS_VENTE,
    };
  },
};
</script>

<style scoped>

</style>
